import { Grid } from '@mui/material';
import { ODSLoadingSpinner } from '@telekom-ods/react-ui-kit';
import React, { type ReactNode } from 'react';

interface SpinnerLoaderProps {
  isLoading: boolean;
  size?: 'small' | 'large';
  labelText: string;
  labelAlignment?: 'horizontal' | 'vertical';
  children?: ReactNode;
  height?: string | number;
  width?: string | number;
}

const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({
  isLoading,
  size = 'small',
  labelText,
  labelAlignment = 'vertical',
  children = null,
  height = '100%',
  width = '100%',
}) => {
  if (!isLoading) return children;
  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      style={{ height, width }}
      data-testid='spinner-wrapper'
    >
      <ODSLoadingSpinner
        size={size}
        labelText={labelText}
        labelAlignment={labelAlignment}
      />
    </Grid>
  );
};

export default SpinnerLoader;
